export const testimonials = [
  {
    id: 1,
    name: "Nicole Sanchez",
    avatar: "https://public.readdy.ai/ai/img_res/d67b128dcac04b6e789e96cb7e371a35.jpg",
    rating: 5,
    quote: "I couldn\u2019t be happier with my experience! I had very specific ideas for my wedding dress, and the team executed every single detail perfectly\u2014exactly how I imagined. They were incredibly attentive, detail-oriented, and kind throughout the entire process. The result is absolutely stunning, and I cannot wait to wear it on my wedding day. A huge thank you to the team for making this such a wonderful experience! \u2764\ufe0f",
    marriedDate: "Spring 2025",
    tier: "Signature"
  },
  {
    id: 2,
    name: "Catherine",
    avatar: "https://readdy.ai/api/search-image?query=elegant%20woman%20with%20light%20brown%20hair%20soft%20natural%20smile%20portrait%20headshot%20cream%20background%20warm%20lighting%20professional%20photography%20beautiful%20bride&width=200&height=200&seq=catherine-avatar&orientation=squarish",
    rating: 5,
    quote: "My wedding dress was completely handmade, and the craftsmanship was unbelievable \u2014 everyone kept complimenting how perfectly it fit, like it was made just for me. I didn\u2019t wear it for 7 months before my wedding, and it stayed in perfect condition the entire time.",
    marriedDate: "Summer 2025",
    tier: "Couture"
  },
  {
    id: 3,
    name: "Mary C.",
    avatar: "https://readdy.ai/api/search-image?query=woman%20with%20auburn%20hair%20bright%20warm%20smile%20portrait%20headshot%20soft%20cream%20background%20natural%20light%20professional%20elegant%20photography%20beautiful&width=200&height=200&seq=maryc-avatar&orientation=squarish",
    rating: 5,
    quote: "The attention to detail was absolutely beautiful, especially with the Mikado silk fabric I chose. Every stitch felt thoughtful, and the fit was nothing short of perfect. When I finally put the dress on, I couldn\u2019t stop smiling as it felt exactly what I envisioned, and saved me easily $10,000 based on the design I chose. This wasn\u2019t just a dress, it was a heartfelt experience, and I\u2019m so grateful for the care and love that went into creating from the team.",
    marriedDate: "Autumn 2025",
    tier: "Signature"
  }
];
